<template>
  <cadastro-base :salvar="salvar">
    <template slot="conteudo">
      <b-row class="mb-1">
        <b-col cols="6">
          <b-row no-gutters>
            <b-col>
              <b-form-group
                label="Nome"
                class="mb-50"
              >
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Nome"
                >
                  <b-input
                    v-model="form.nome"
                    :state="errors.length > 0 ? false:null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col>
              <b-form-checkbox
                v-model="form.externo"
                class="detail-check-sm"
                size="sm"
                @change="mudarMenus"
              >
                Externo
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição (opcional)">
            <b-textarea v-model="form.descricao" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="!form.externo"
        no-gutters
      >
        <b-col
          cols="auto"
          class="mr-3"
        >
          <b-form-checkbox
            v-model="form.administrador"
            class="detail-check-sm"
            size="sm"
            @change="aplicarAdministrador"
          >
            Administrador
          </b-form-checkbox>
        </b-col>
        <b-col
          cols="auto"
          class="mr-3"
        >
          <b-form-checkbox
            v-model="form.permitidoDownloadA1Cnpj"
            class="detail-check-sm"
            size="sm"
          >
            Permitir download de A1 e-CNPJ
          </b-form-checkbox>
        </b-col>
        <b-col cols="auto">
          <b-form-checkbox
            v-model="form.permitidoDownloadA1Cpf"
            class="detail-check-sm"
            size="sm"
          >
            Permitir download de A1 e-CPF
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12 p-0 m-0">
          <hr class="divider">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <menu-permissao
            ref="permissoes"
            v-model="form.moduloRecursos"
            :admin="form.administrador"
          />
        </b-col>
      </b-row>
    </template>
  </cadastro-base>
</template>

<style lang="scss">
.detail-check-sm.custom-checkbox.b-custom-control-sm
  .custom-control-label::before,
.detail-check-sm.input-group-sm .custom-checkbox .custom-control-label::before {
  left: 0px !important;
}

.detail-check-sm.custom-checkbox.b-custom-control-sm .custom-control-label {
  font-size: 0.95rem !important;
}
</style>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import api from '../../services/api'

export default {
  name: 'GrupoUsuarioCadastro',
  components: {
    CadastroBase: () => import('@/shared/components/cadastro-base/CadastroBase.vue'),
    MenuPermissao: () => import('../menu-permissao/MenuPermissao.vue'),
    ValidationProvider,
  },
  data() {
    return {
      required,
      form: {
        nome: '',
        descricao: null,
        externo: false,
        moduloRecursos: [],
        administrador: false,
        permitidoDownloadA1Cnpj: false,
        permitidoDownloadA1Cpf: false,
      },
      recursosSel: 0,
      recursosValido: true,
      recursoInvalidoMsg: '',
      state: '',
      selectionType: 'independent',
      selection: [],
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    } else {
      this.carregarRecursos(false)
    }
  },
  methods: {
    carregar(id) {
      api.getGrupo(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    carregarRecursos(externo) {
      api.getRecursos(externo)
        .then(payload => {
          this.form.moduloRecursos = payload.data
        })
    },
    mudarMenus(value) {
      this.form.administrador = false
      this.form.moduloRecursos = []
      this.carregarRecursos(value)
    },
    aplicarAdministrador(value) {
      this.$refs.permissoes.selecionarTudo(value)
    },
    validarModuloPermissoes(value) {
      for (let i = 0; i < value.length; i += 1) {
        const moduloRecurso = value[i]
        this.validarPermissoes(moduloRecurso.filhos)
      }
    },
    validarPermissoes(value) {
      for (let i = 0; i < value.length; i += 1) {
        const recurso = value[i]
        this.recursosSel += recurso.habilitado && !recurso.root ? 1 : 0
        // Se foi selecionado pelo usuário
        if (recurso.habilitado && (!recurso.filhos || recurso.filhos.length === 0)) {
          if (!recurso.permissao
            || (!recurso.permissao.adicionar && !recurso.permissao.visualizar && !recurso.permissao.alterar && !recurso.permissao.remover)) {
            this.recursosValido = false
            this.recursoInvalidoMsg = 'Existem recursos selecionados sem nenhuma permissão informada.'
            break
          }
          if (!recurso.permissao
            && (!recurso.permissao.visualizar && (recurso.permissao.adicionar || recurso.permissao.alterar || recurso.permissao.remover))) {
            this.recursosValido = false
            this.recursoInvalidoMsg = 'Caso uma dessas permissões estiver habilitada: "Adicionar", "Alterar" ou "Remover". A permissão de visualização deve estar habilitada'
            break
          }
        } else if (recurso.filhos && recurso.filhos.length > 0) {
          this.validarPermissoes(recurso.filhos)
        }
      }
    },
    salvar() {
      return new Promise((resolve, reject) => {
        this.recursosValido = true
        if (!this.form.administrador) {
          this.validarModuloPermissoes(this.form.moduloRecursos)
          if (this.recursosSel === 0) {
            this.recursosValido = false
            this.recursoInvalidoMsg = 'Necessário selecionar ao menos um recurso.'
          }
        }

        if (!this.recursosValido) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.recursoInvalidoMsg,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
        } else if (this.state === 'novo') {
          api.createGrupo(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Grupo de usuário cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateGrupo(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Grupo de usuário alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
  },
  cancelar() {
    this.$router.go(-1)
  },
}
</script>
